"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const commandCell = (mode, row) => ({
    position: 'sticky',
    left: 0,
    textAlign: 'center',
    backgroundColor: mode == 'dark' ? row % 2 == 0 ? '#272936' : 'inherit' : 'none',
});
const editIcon = {
    fontSize: 'large',
    cursor: 'pointer',
    marginRight: 5,
    color: '#404041'
};
const deleteIcon = {
    fontSize: 'large',
    cursor: 'pointer',
    marginRight: 5,
    color: '#404041'
};
const resetPasswordIcon = {
    fontSize: 'large',
    cursor: 'pointer',
    color: '#404041'
};
const icon = (margin) => ({
    fontSize: 'large',
    cursor: 'pointer',
    marginRight: margin ? 5 : undefined,
    color: '#404041'
});
exports.default = {
    commandCell,
    editIcon,
    deleteIcon,
    resetPasswordIcon,
    icon
};
